<template>
  <v-transition name="slide-up" :hash="'group-progress-' + IClassroom.group._id">
    <div v-if="IClassroom.lastCourseMessage" class="progress-wrapper">
      <div class="progress-bar">
        <div v-for="i in total"
             class="progress-block"
             :key="'progress-block-' + i"
             :class="{'is-active': i <= (total-remaining)}">

          <div v-if="IClassroom.courseMessages[i-1]"
               @click="IClassroom.focusToMessage(IClassroom.courseMessages[i-1])">
            <a v-if="IClassroom.courseMessages[i-1].type === MessageType.VIDEO">
              <v-color-icon :size="14" name="video-s"></v-color-icon>
            </a>
            <a v-else-if="IClassroom.courseMessages[i-1].id === -200">
              <v-color-icon :size="14" name="star-fill"></v-color-icon>
            </a>
            <a v-else-if="IClassroom.courseMessages[i-1].type === MessageType.CODE">
              <v-color-icon :size="14" name="code-slash"></v-color-icon>
            </a>
            <a v-else-if="IClassroom.courseMessages[i-1].type === MessageType.PROGRAMMING">
              <v-color-icon :size="14" name="code-box-fill"></v-color-icon>
            </a>
            <a v-else-if="IClassroom.courseMessages[i-1].type === MessageType.CHECKPOINT">
            <v-color-icon :size="14" name="flag"></v-color-icon>
            </a>
            <span v-else></span>
          </div>
        </div>
      </div>
      <span v-tooltip="'课堂内容会根据你的学习情况动态调整'"
            class="tip is-text-xs pull-right">课堂进度 {{ total - remaining }}/{{ total }} <v-color-icon size="14"
                                                                                                     name="question-line"></v-color-icon></span>
    </div>
  </v-transition>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import { MessageType } from '@/components/classroom/lib/Message'

export default {
  data () {
    return {
      IClassroom,
      MessageType
    }
  },
  computed: {
    remaining () {
      return IClassroom.lastCourseMessage && IClassroom.lastCourseMessage.dist || 0
    },
    total () {
      return IClassroom.courseMessages.length + this.remaining
    }
  }
}
</script>

<style lang="stylus" scoped>
.progress-wrapper {
  display block
  width 100%
  position relative
}

.tip {
  margin-top 2px
  position absolute
  top: -27px
  right 0
  color $linkLight
  opacity .8
}

.progress-bar {
  width 100%
  display flex
  position absolute
  transform translateY(-50%)
}

.progress-block {
  height 5px
  background $linkFront
  flex-grow 1
  margin 2px
  min-width 2px
  border-radius 3px
  text-align center
  position relative
  transition all .3s

  &:before {
    content ''
    border-radius 3px
    transition all .6s
    position absolute
    background white
    left 0
    top 0
    width 100%
    height 100%
    transform scaleX(0)
    transform-origin left center
  }

  &.is-active {
    cursor pointer

    &:before {
      transform scaleX(1)
    }

    &:hover {
      transform translateY(-4px)
    }
  }
}
</style>
